module.exports = __webpack_public_path__ + "images/marketing_site/CRM_HighPerformer_Enterprise_HighPerformer.svg";